// Import extend function.
import '../../../js/vendor/polyfills/polyfill-includes.js';
import Component from '../../../js/core/component.js';
import isVisible from '../../../js/utilities/is-visible/u-is-visible.js';

class FormConditions extends Component {

	_defaultSettings () {
		return {
			debug: false,
			requiredElements: []
		};
	}

	_init () {
		if (this.inited) {
			this._log('Conditions is already inited');
			return;
		}

		this.inited = true;
	}

	initEventListeners (rules) {
		const elementWithEventListeners = [];
		rules.forEach(rule => {
			if (rule.status === 'stop') {
				return;
			}
			let element;
			let type;
			let elements;

			try {
				elements = this._getConditionElement(rule.conditions[0].sourceEl, rule.conditions[0].value, false, rule.conditions[0].operator);
				element = this._getConditionElement(rule.conditions[0].sourceEl, rule.conditions[0].value, true, rule.conditions[0].operator);
				type = this._getControlType(elements[0]);

				// Check if element already has event listener if multiple rules
				if (!elementWithEventListeners.includes(elements[0].name)) {
					this._setupTriggers(elements, type, rules);
					elementWithEventListeners.push(elements[0].name);
				}

				this._setupAriaControls(element, rule.actions);

				// Skip multiple conditions rules
				if (rule.conditions.length > 1) {
					return;
				}
			}
			catch (error) {
				this._throwError('Kunde inte sätta upp trigger och aria-attribut', rule, error);
			}
		});
	}

	executeAllRules (rules) {
		// Loop through rules
		rules.forEach(rule => {
			if (rule.conditions.length > 1) {
				return;
			}

			let element;
			let type;
			let conditionIsValid;

			try {
				element = this._getConditionElement(rule.conditions[0].sourceEl, rule.conditions[0].value, true, rule.conditions[0].operator);
				type = this._getControlType(element);
				conditionIsValid = this._evalCondition(rule.conditions[0].operator, element, type, rule.conditions[0].value);

				this._runActions(rule.actions, conditionIsValid, element);
				this._toggleRequired();
			}
			catch (error) {
				this._throwError('Kunde inte köra regler och toggla required', rule, error);
			}
		});
	}

	_executeRule (rules, triggerEl) {
		let rulesAffected = this._getRule(rules, triggerEl);
		rulesAffected.forEach(rule => {
			let type = this._getControlType(triggerEl);
			let conditionIsValid = this._evalCondition(rule.conditions[0].operator, triggerEl, type, rule.conditions[0].value);

			this._runActions(rule.actions, conditionIsValid, triggerEl);
			this._toggleRequired();
		});
	}

	_getRule (rules, element) {
		let rulesToReturn = [];
		rules.forEach(rule => {
			if (rule.conditions[0].sourceEl === element.name) {
				rulesToReturn.push(rule);
			}
		});
		return rulesToReturn;
	}

	_setupTriggers (element, type, rules) {
		switch (type) {
			case 'select':
				element[0].addEventListener('change', () => {
					this._executeRule(rules, element[0]);
				});
				break;
			case 'radio':
			case 'checkbox':
				element.forEach(item => {
					item.addEventListener('change', () => {
						this._executeRule(rules, item);
					});
				});
				break;
			case 'text':
			case 'hidden':
				element[0].addEventListener('input', () => {
					this._executeRule(rules, element[0]);
				});
				break;
			default:
				break;
		}
	}

	_setupAriaControls (el, actions) {
		let controls = el.getAttribute('aria-controls');

		actions.forEach((action => {
			if (controls !== null) {
				if (!controls.includes(`conditional-${action.actionEl}`)) {
					controls += ` conditional-${action.actionEl}`;
				}
			}
			else {
				controls = `conditional-${action.actionEl}`;
			}
		}));

		el.setAttribute('aria-controls', controls);
	}

	_evalCondition (operator, el, type, value) {
		switch (operator) {
			case 'eq':
				return this._opEqual(el, type, value);
			case '!eq':
				return this._opNotEqual(el, type, value);
			case 'contain':
				return this._opContains(el, type, value);
			case '!contain':
				return this._opNotContains(el, type, value);
			case 'empty':
				return this._opEmpty(el, type);
			case '!empty':
				return this._opNotEmpty(el, type);
			default:
				break;
		}
	}

	_runActions (actions, valid, sourceEl) {
		actions.forEach(action => {
			switch (action.action) {
				case 'hideAndClear':
					if (valid) {
						this._hide(action.actionEl, sourceEl, true);
					}
					else {
						this._show(action.actionEl, sourceEl);
					}
					break;
				case 'hide':
					if (valid) {
						this._hide(action.actionEl, sourceEl);
					}
					else {
						this._show(action.actionEl, sourceEl, false);
					}
					break;
				case 'show':
					if (valid) {
						this._show(action.actionEl, sourceEl);
					}
					else {
						this._hide(action.actionEl, sourceEl, false);
					}
					break;
				/* case 'require':
					if (valid) {
						this._require(action.actionEl);
					}
					else {
						this._optional(action.actionEl);
					}
					break;
				case 'optional':
					if (valid) {
						this._optional(action.actionEl);
					}
					else {
						this._require(action.actionEl);
					}
				break; */
				default:
					break;
			}
		});
	}

	_toggleRequired () {
		this.settings.requiredElements.forEach(el => {
			let elementIsVisible = isVisible(el);
			if (elementIsVisible && !(el.hasAttribute('required'))) {
				el.setAttribute('required', '');
			}
			else if (!elementIsVisible) {
				el.removeAttribute('required');
			}
		});
	}

	/**
	 * Actions
	 */
	_show (actionName, sourceEl) {
		let actionEl = document.querySelector(`[data-action="${actionName}"`);
		if (actionEl) {
			actionEl.style.display = '';
		} else {
			console.log('[show] Action element not found', actionEl);
		}
		if (sourceEl) {
			sourceEl.setAttribute('aria-expanded', true);
		} else {
			console.log('[show] Source element not found', sourceEl);
		}
	}

	_hide (actionName, sourceEl, clear) {
		let actionEl = document.querySelector(`[data-action="${actionName}"`);
		if (sourceEl) {
			actionEl.style.display = 'none';
			sourceEl.setAttribute('aria-expanded', false);
		} else {
			console.log('[hide] Source element not found', sourceEl);
		}

		if (actionEl) {

			// Check if fields should be cleared
			if (clear) {
				this._clearAllFields(actionEl);
			}
		} else {
			console.log('[hide] Action element not found', actionEl);
		}
	}

	_require (actionName) {
		let actionEl = document.querySelector(`[name="${actionName}"`);
		actionEl.setAttribute('required', '');
	}

	_optional (actionName) {
		let actionEl = document.querySelector(`[name="${actionName}"`);
		actionEl.removeAttribute('required');
	}

	/**
	 * Operators
	 */
	_opEqual (el, type, value) {
		let sourceValue = this._getSelectedValue(el, type);
		let result = (sourceValue === value) ? true : false;
		return result;
	}

	_opNotEqual (el, type, value) {
		let sourceValue = this._getSelectedValue(el, type);
		let result = (sourceValue !== value) ? true : false;
		return result;
	}

	_opContains (el, type, value) {
		let result;
		let sourceValue = this._getSelectedValue(el, type);

		if (type === 'radio' || type === 'checkbox') {
			if (sourceValue.includes(value) > 0 && el.checked) {
				result = true;
			}
			else {
				result = false;
			}
		}
		else {
			if (typeof(sourceValue) !== 'undefined') {
				if (sourceValue.includes(value)) {
					result = true;
				}
				else {
					result = false;
				}
			}
			else {
				result = false;
			}
		}
		return result;
	}

	_opNotContains (el, type, value) {
		let result;
		let sourceValue = this._getSelectedValue(el, type);

		if (type === 'radio' || type === 'checkbox') {
			if (sourceValue.includes(value) > 0 && el.checked) {
				result = false;
			}
			else {
				result = true;
			}
		}
		else {
			if (typeof(sourceValue) !== 'undefined') {
				if (sourceValue.includes(value)) {
					result = false;
				}
				else {
					result = true;
				}
			}
			else {
				result = true;
			}
		}
		return result;
	}

	_opEmpty (el, type) {
		let sourceValue = this._getSelectedValue(el, type);
		if (type === 'radio' || type === 'checkbox') {
			return (el.checked) ? false : true;
		}
		else {
			return (sourceValue === '') ? true : false;
		}
	}

	_opNotEmpty (el, type) {
		let sourceValue = this._getSelectedValue(el, type);
		if (type === 'radio' || type === 'checkbox') {
			return (el.checked) ? true : false;
		}
		else {
			return (sourceValue === '') ? false : true;
		}
	}

	/**
	 * Helpers
	 */
	_getConditionElement (sourceElement, value, single, operator) {
		let elements = Array.from(document.querySelectorAll(`[name="${sourceElement}"`));

		if (!single) {
			return elements;
		}
		else {
			if (elements.length > 1) {
				return this._getElementByValue(elements, value, operator);
			}
			else {
				return elements[0];
			}
		}
	}

	_getSelectedValue (el, type) {
		let selectedVal;
		switch (type) {
			case 'text':
			case 'radio':
			case 'checkbox':
			case 'hidden':
				selectedVal = el.value;
				break;
			case 'select':
				selectedVal = el.options[el.selectedIndex].text;
				break;
			default:
				break;
		}
		return selectedVal;
	}

	_getControlType (el) {
		if (el.tagName.toLowerCase() === 'input') {
			return el.type;
		}
		else {
			return el.tagName.toLowerCase();
		}
	}

	_getElementByValue (elements, value, operator) {
		let element;
		if (operator === 'contain' || operator === '!contain') {
			elements.forEach(item => {
				if (item.value.includes(value)) {
					element = item;
				}
			});

		}
		else {
			elements.forEach(item => {
				if (item.value === value) {
					element = item;
				}
			});
		}
		return element;
	}

	_checkCheckboxes (checkboxes) {
		let checked = false;
		checkboxes.forEach(item => {
			if (item.checked) {
				checked = true;
			}
		});
		return checked;
	}

	_clearAllFields (el) {
		let fields = Array.from(el.querySelectorAll('input, select, textarea'));
		fields.forEach(field => {
			let type = this._getControlType(field, false);

			switch (type) {
				case 'select':
					field.selectedIndex = 0;
					this._triggerEvent('change', field);
					break;
				case 'radio':
				case 'checkbox':
					field.checked = false;
					this._triggerEvent('change', field);
					break;
				default:
					field.value = '';
					if (type != 'hidden') {
						this._triggerEvent('input', field);
					}
					break;
			}
		});
	}

	_triggerEvent (type, el) {
		// Trigger change event
		let event = new CustomEvent(type);
		el.dispatchEvent(event);
	}

	_throwError (title, rule, error) {
		console.log(`\n%c⚠️ ${title}`, 'font-weight: bold; font-size: larger;');
		console.log(`➡️ Element som triggar regel: ${rule.conditions[0].sourceEl}`);
		console.log(`➡️ Värdet som försöker matchas: ${rule.conditions[0].value}`);
		console.log(`➡️ Operator: ${rule.conditions[0].operator}\n`);
		console.log(`❗️ JS Error: ${error}`);
	}
}

export default FormConditions;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-conditions.js